import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../api/axiosInstance';
const initialState = {
    loading: false,
    success: false,
    error: null,
};

// Create async thunk for the API call
export const requestNewPriceOffer = createAsyncThunk(
    'priceOffer/requestNewPriceOffer',
    async ({ formData, token }, { rejectWithValue }) => {

        try {
            // Prepare data as an object, not stringified
            const response = await axiosInstance.post(
                '/api/Customer/RequestNewPriceOffer',
                formData,  // Directly passing the formData object
                {
                    headers: {
                        'Content-Type': 'application/json',  // Update the content type as required
                        'Authorization': `Bearer ${token}`,
                        'Accept': 'application/json',  // Ensuring the server returns JSON
                    },
                }
            );
          
            
            if (response.status !== 200) {
                throw new Error('Something went wrong');
            }

            return response.data;  // Assuming the server responds with JSON
        } catch (error) {
            // console.error('Error:', error);
            // Improved error handling: capture more details from error response
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const priceOfferSlice = createSlice({
    name: 'priceOffer',
    initialState,
    reducers: {
        resetPriceOfferState: (state) => {
            state.loading = false;
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(requestNewPriceOffer.pending, (state) => {
                state.loading = true;
            })
            .addCase(requestNewPriceOffer.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(requestNewPriceOffer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetPriceOfferState } = priceOfferSlice.actions;

export default priceOfferSlice.reducer;
